"use strict";

export default angular.module("contartemx.administracion.cuentas", [
  "contartemx",
  "ui.bootstrap",
  "tableTools",
  "loader"
])
  .controller("CuentasCtrl", ($scope, $rootScope, $state, $cookies, $filter, $uibModal, apiCall, mostrarNotificacion, NgTableParams, $timeout) => {

    const ContarteAPI = new apiCall($scope);
    const origCounts = [10, 50, 100];

    let cuentas = [];

    $scope.selectedOpt = 1;
    $scope.nuevaCuenta = {
      mostrarControles: false
    };

    const paramsIniciales = { count: 50 },
      actualizarTablas = r => {

        if (r.CodigoRespuesta == 200 && angular.isArray(r.Respuesta)) {
          
          r.Respuesta.forEach(c => {
            // Acciones
            c.Acciones = {
              Ingresar: c.EstaActivo && c.MembresiaActiva && !c.InvitacionPendiente,
              InvitacionPendiente: c.EstaActivo && c.MembresiaActiva && c.InvitacionPendiente,
            };
            c.Acciones.Administrar = c.CveTipoUsuario < 4 && (!c.CveOrganizacion || c.EsTitular);
            c.Acciones.RenovarMembresia = c.EstaActivo && !c.MembresiaActiva && !c.InvitacionPendiente && c.CveTipoUsuario < 4 && (!c.CveOrganizacion || c.EsTitular);

            c.paraBusqueda = `${c.RFC} ${c.NombreContribuyente} ${c.Organizacion ? c.Organizacion.Nombre : ''}`;
          });

          cuentas = r.Respuesta;
          $scope.cuentas = cuentas;

          const parametros = angular.extend({}, paramsIniciales);

          $scope.tableParamsCuentas = new NgTableParams(parametros,
            {
              dataset: $scope.cuentas,
              counts: $scope.cuentas.length > parametros.count ? origCounts : [],
            });

          $scope.mostrarCuentas(1);
          refrescarTablas();
          $scope.noTieneCuentas = $scope.cuentas.length == 0;

        } else {
          mostrarNotificacion.error(r.Mensaje);
        }
      },
      refrescarTablas = () => {

        const parametros = angular.extend({}, paramsIniciales);

        $scope.deselectCuenta();

        // Se obtienen los parametros viejos para no cambiar la interfaz al usuario.
        if (angular.isObject($scope.tableParamsCuentas)) {
          if (($scope.cuentas.length / $scope.tableParamsCuentas.count()) < $scope.tableParamsCuentas.page()) {
            parametros.page = Math.floor($scope.cuentas.length / $scope.tableParamsCuentas.count()) || 1;
          } else {
            parametros.page = $scope.tableParamsCuentas.page() || 1;
          }

          parametros.count = $scope.tableParamsCuentas.count();
          parametros.sorting = $scope.tableParamsCuentas.sorting({ CveTipoUsuario: 'asc', Nombre: 'asc' });
        }

        $scope.tableParamsCuentas = new NgTableParams(parametros,
          {
            dataset: $scope.cuentas,
            counts: $scope.cuentas.length > parametros.count ? origCounts : []
          });
      };

    $scope.$watch(() => {
      return $scope.tableParamsCuentas ? $scope.tableParamsCuentas.sorting() : null;
    }, (nuevoOrden, viejoOrden) => {
      if (nuevoOrden != viejoOrden) {
        let columna = '';
        for (let prop in nuevoOrden) {
          columna = prop;
          break;
        }
        // TODO: No es un estandar el orden de las propiedades. Esperar feature de ngTable para ordenamiento de multiples columnas.
        if (columna && nuevoOrden[columna]) {
          var val = nuevoOrden[columna];
          delete nuevoOrden[columna];
          nuevoOrden.CveTipoUsuario = 'asc';
          nuevoOrden[columna] = val;
          $scope.tableParamsCuentas.sorting(nuevoOrden);
        }
      }
    });

    $scope.aplicarBuscador = () => {
      if ($scope.tableParamsCuentas) {
        if ($scope.buscador) {
          $scope.tableParamsCuentas.filter({
            paraBusqueda: $scope.buscador
          });
        } else {
          $scope.tableParamsCuentas.filter({});
        }
      }
    };

    $scope.borrarBuscador = () => {
      $scope.buscador = '';
      $scope.aplicarBuscador();
    };

    $timeout(() => {
      $scope.tableParamsCuentas ? $scope.tableParamsCuentas.sorting({ CveTipoUsuario: 'asc' }) : null;
    });

    const obtenerCuentasDeUsuario = () => ContarteAPI.post("ObtenerCuentasDeUsuario")
      .then(actualizarTablas);

    const confirmarInvitacionColaboracion = (data) => ContarteAPI.post("ConfirmarInvitacionColaboracion", data)
      .then(actualizarTablas);

    obtenerCuentasDeUsuario();

    $scope.mostrarCuentas = indice => {
      $scope.selectedOpt = indice;
      if (indice == 2) {
        $scope.cuentas = cuentas.filter(c => !c.EstaActivo);
      } else {
        $scope.cuentas = cuentas.filter(c => c.EstaActivo);
      }
      refrescarTablas();
    };

    $scope.cambiarContribuyente = cveContribuyente => {
      $scope.loading = true;
      $rootScope.$broadcast("CambioContribuyente", cveContribuyente);
    };

    $scope.editarContribuyente = cuenta => $state.go('administracion.cuenta_detalle', { cveContribuyente: cuenta.ClaveContribuyente });

    $scope.modalNuevaCuenta = (cuenta) => {

      const modalInstance = $uibModal.open({
        template: require('../../../../../app/views/Administracion/Cuentas/NuevaCuenta_modal.html'),
        controller: 'NuevaCuentaContribuyenteCtrl',
        windowClass: 'modal--small',
        resolve: {
          cuenta() {
            return cuenta;
          }
        }
      });

      modalInstance.result.then((data) => {
        if (data.CodigoRespuesta == 200) {
          mostrarNotificacion.info(data.Mensaje);
          obtenerCuentasDeUsuario();
        } else {
          mostrarNotificacion.error(data.Mensaje);
        }
      });
    };

    $scope.desactivarCuenta = (cuenta) => {

      const modalInstance = $uibModal.open({
        template: require('../../../../../app/views/Administracion/Cuentas/DesactivarCuenta_modal.html'),
        controller: 'DesactivarCuentaContribuyenteCtrl',
        windowClass: 'modal--small',
        appendTo: angular.element(document.querySelector('.modal-parent')),
        resolve: {
          cuenta() {
            return cuenta;
          }
        }
      });

      modalInstance.result.then((data) => {
        if (data.CodigoRespuesta == 200) {
          obtenerCuentasDeUsuario();
          mostrarNotificacion.info(data.Mensaje);
        } else {
          mostrarNotificacion.error(data.Mensaje);
        }
      });
    };

    $scope.reactivarCuenta = (cuenta) => {

      const modalInstance = $uibModal.open({
        template: require('../../../../../app/views/Administracion/Cuentas/ReactivarCuenta_modal.html'),
        controller: 'ReactivarCuentaContribuyenteCtrl',
        windowClass: 'modal--small',
        appendTo: angular.element(document.querySelector('.modal-parent')),
        resolve: {
          cuenta() {
            return cuenta;
          }
        }
      });

      modalInstance.result.then((data) => {
        if (data.CodigoRespuesta == 200) {
          obtenerCuentasDeUsuario();
          mostrarNotificacion.info(data.Mensaje);
        } else {
          mostrarNotificacion.error(data.Mensaje);
        }
      });
    };

    $scope.popoverConfirmarInvitacion = {
      template: '../../../../../ng-contartemx/app/views/Administracion/Cuentas/ConfirmaInvitacion_popover.html',
      triggers: 'click outsideClick'
    };

    $scope.popoverRenovarMembresia = {
      template: '../../../../../ng-contartemx/app/views/Administracion/Cuentas/RenovarMembresia_popover.html',
      triggers: 'click outsideClick'
    };

    $scope.aceptarInvitacion = (CveContribuyente) => {
      confirmarInvitacionColaboracion({
        CveContribuyente,
        Acepto: true
      });
    };

    $scope.verDetalleContribuyente = (cveContribuyente) => {
      $state.go('administracion.cuenta_detalle', {cveContribuyente});
    };

    $scope.rechazarInvitacion = (CveContribuyente) => {
      confirmarInvitacionColaboracion({
        CveContribuyente,
        Acepto: false
      });
    };

    $scope.EnviarCorreoMembresia = (CveContribuyente) => {

      let data = { subject: "Adquirir/Renovar membresia", CveContribuyente };
      ContarteAPI.post('EnviarCorreoTimbresMembresias', data)
        .then((res) => {
          if (res.EsError) {
            mostrarNotificacion.error("Hubo un error al mandar la petición");
          } else {
            mostrarNotificacion.info("Se ha enviado tu petición.");
          }
        }, (error) => {
          mostrarNotificacion.error("Hubo un error al mandar la petición.");
        });
    };

    $scope.selectCuenta = cuenta => {
      $scope.deselectCuenta();
      cuenta.IsSelected = true;
      $scope.cuentaTitularSeleccionada = cuenta;
    };

    $scope.deselectCuenta = () => {
      $scope.cuentaTitularSeleccionada = null;
      if (angular.isArray($scope.cuentas)) {
        $scope.cuentas.forEach(c => c.IsSelected = false);
      }
    };

    // Menú Contextual de Cuentas
    $scope.contextMenuCuentas = [
      // Acciones para una sola transacción
      {
        html: '<a><span class="icon icon--circleAccess contextMenu__icon"></span>Ingresar</a>',
        displayed: $itemScope => $itemScope && $itemScope.cuenta && $itemScope.cuenta.Acciones && $itemScope.cuenta.Acciones.Ingresar,
        click($itemScope, $event, modelValue, text, $li) {
          if ($itemScope && $itemScope.cuenta) {
            $scope.cambiarContribuyente($itemScope.cuenta.ClaveContribuyente);
          }
        }
      },
      {
        html: '<a><span class="icon icon--gear contextMenu__icon"></span>Administrar</a>',
        displayed: $itemScope => $itemScope && $itemScope.cuenta && $itemScope.cuenta.Acciones && $itemScope.cuenta.Acciones.Administrar,
        click($itemScope, $event, modelValue, text, $li) {
          if ($itemScope && $itemScope.cuenta) {
            $state.go('administracion.cuenta_detalle', { cveContribuyente: $itemScope.cuenta.ClaveContribuyente });
          }
        }
      },
      {
        html: '<a><span class="icon icon--circleCross contextMenu__icon"></span>Desactivar</a>',
        displayed: $itemScope => $scope.selectedOpt == 1 && $itemScope.cuenta.Acciones && $itemScope.cuenta.Acciones.Administrar,
        click($itemScope, $event, modelValue, text, $li) {
          if ($itemScope && $itemScope.cuenta) {
            $scope.desactivarCuenta($itemScope.cuenta);
          }
        }
      },
      {
        html: '<a><span class="icon icon--circleCross contextMenu__icon"></span>Reactivar</a>',
        displayed: $itemScope => !$itemScope.cuenta.EstaActivo && $itemScope.cuenta.Acciones && $itemScope.cuenta.Acciones.Administrar,
        click($itemScope, $event, modelValue, text, $li) {
          if ($itemScope && $itemScope.cuenta) {
            $scope.reactivarCuenta($itemScope.cuenta);
          }
        }
      }
    ];

  });
